/** @format */

import { ProductReviewed, Review, ReviewSummary, Statistics } from '../../model';
import { createAction, props } from '@ngrx/store';

import { ReviewAISummaryResponse } from '@shared/data-access/interfaces';

/**
 * Action types initialization
 */
export enum ProductReviewActionTypes {
	ADD_REVIEWS_MULTIMEDIA = '[Product Reviews] Add Reviews Multimedia',
	CLEAN_REVIEWS_MULTIMEDIA = '[Product Reviews] Clean Reviews Multimedia',
	LOAD_REVIEW_AI_SUMMARY = '[Product Reviews] Load Review AI Summary',
	SET_BV_PIXEL_IS_AVAILABLE = '[Product Reviews] BV Pixel is available',
	SET_BV_PIXEL_STATE = '[Product Reviews] Set BV Pixel State',
	SET_PRODUCT_REVIEWS = '[Product Reviews] Set Product Reviews',
	SET_PRODUCT_REVIEW_PRODUCT_IDENTIFIER = '[Product Reviews] Set Product Identifier',
	SET_PRODUCT_REVIEW_STATE = '[Product Reviews] Set Product Review State',
	SET_PRODUCT_REVIEW_SUMMARY = '[Product Reviews] Set Product Review Summary',
	SET_PRODUCT_STATISTICS = '[Product Reviews] Set Product Statistics',
	SET_REVIEW_AI_SUMMARY = '[Product Reviews] Set Review AI Summary',
	SET_REVIEW_ON_DRAWER = '[Product Reviews] Set Review On Drawer',
	UPDATE_REVIEWS_MULTIMEDIA = '[Product Reviews] Update Reviews Multimedia'
}

/**
 * Actions initialization
 */
export const setProductReviewState = createAction(
	ProductReviewActionTypes.SET_PRODUCT_REVIEW_STATE,
	props<{
		product: ProductReviewed;
		productIdentifier: string;
		reviewSummary: ReviewSummary;
		reviews: Review[];
	}>()
);

export const setProductReviewProductIdentifier = createAction(
	ProductReviewActionTypes.SET_PRODUCT_REVIEW_PRODUCT_IDENTIFIER,
	props<{ productIdentifier: string }>()
);

export const setProductReviewSummary = createAction(
	ProductReviewActionTypes.SET_PRODUCT_REVIEW_SUMMARY,
	props<{ reviewSummary: ReviewSummary }>()
);

export const setProductReviews = createAction(
	ProductReviewActionTypes.SET_PRODUCT_REVIEWS,
	props<{ reviews: Review[] }>()
);

export const loadReviewAISummary = createAction(
	ProductReviewActionTypes.LOAD_REVIEW_AI_SUMMARY,
	props<{ productId: string }>()
);

export const setReviewAISummary = createAction(
	ProductReviewActionTypes.SET_REVIEW_AI_SUMMARY,
	props<{ aiReview: ReviewAISummaryResponse}>()
);

export const setProductStatistics = createAction(
	ProductReviewActionTypes.SET_PRODUCT_STATISTICS,
	props<{ statistics: Statistics }>()
);

export const setReviewOnDrawer = createAction(
	ProductReviewActionTypes.SET_REVIEW_ON_DRAWER,
	props<{ currentReview: string }>()
);

export const addProductReviewsMultimedia = createAction(
	ProductReviewActionTypes.ADD_REVIEWS_MULTIMEDIA,
	props<{ reviewsMultimedia: Review[] }>()
);

export const cleanProductReviewsMultimedia = createAction(
	ProductReviewActionTypes.CLEAN_REVIEWS_MULTIMEDIA
);

export const updateProductReviewsMultimedia = createAction(
	ProductReviewActionTypes.UPDATE_REVIEWS_MULTIMEDIA,
	props<{ reviewMultimedia: Review }>()
);

export const setBVPixelState = createAction(
	ProductReviewActionTypes.SET_BV_PIXEL_STATE,
	props<{
		brand: string;
		category: string;
		productId: string;
	}>()
);

export const setBVPixelIsAvailable = createAction(
	ProductReviewActionTypes.SET_BV_PIXEL_IS_AVAILABLE,
	props<{
		isBVPixelReady: boolean
	}>()
);
